import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTrophy: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconTrophy"><Path fillRule="evenodd" clipRule="evenodd" d="M5 2H19V4H22V7C22 9.09706 20.3862 10.8172 18.3328 10.9864C17.3487 13.0696 15.3669 14.5892 13.0039 14.9286V17H18V22H6V17H11.0039V14.9297C8.63747 14.5925 6.65237 13.0719 5.66717 10.9864C3.61375 10.8172 2 9.09706 2 7V4H5V2ZM5 6H4V7C4 7.75678 4.42032 8.41539 5.04025 8.7551C5.01365 8.50705 5 8.25512 5 8V6ZM19 6V8C19 8.25512 18.9864 8.50705 18.9597 8.7551C19.5797 8.41539 20 7.75678 20 7V6H19Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTrophy;
